import { IModuleDefinition } from 'modules/types'
import { combineReducers } from 'redux'
import Activity, { rdot360ActivitydReducer } from './Activity'
import Balances, { rdot360BalanceReducer } from './Balances'
import Collaboration, { rdot360CollaborationReducer } from './Collaboration'
import Dashboard, { rdot360DashboardReducer } from './Dashboard'
import Performance from './Dashboard/Performance'
import Documents from './Documents'
import GainAndLosses from './GainAndLosses'
import Income from './Income'
import Investments, { investmentsModuleReducer } from './Investments'
import Revenue, { rdot360RevenueReducer } from './Revenue'

export default [
  Balances,
  Dashboard,
  Activity,
  Investments,
  Income,
  GainAndLosses,
  Revenue,
  Performance,
  Documents,
  Collaboration
] as IModuleDefinition[]

export const rdot360ModulesReducer = combineReducers({
  dashboard: rdot360DashboardReducer,
  activity: rdot360ActivitydReducer,
  balance: rdot360BalanceReducer,
  revenue: rdot360RevenueReducer,
  collaboration: rdot360CollaborationReducer,
  investments: investmentsModuleReducer
})
